import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { getUserInfoDataForEAPM } from '../../tools/utils/utils';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'POST_USER_ACCEPTANCE_TOU';

export const usePostUserAcceptanceTOU = () => {
  const result = useSelector((state) => state[ACTION_TYPE]);

  const action = useAction((args) => {
    const eapm = window.elasticApm;
    let transaction;
    let status;
    let statusText;
    let dtrumActionId;
    if (eapm) {
      transaction = eapm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: false,
      });
    }
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('DS_NEW_PROXY_URL')}${config('USER_ACCEPTANCE_TOU')}?q=${ACTION_TYPE}`);
      fetch(`${config('DS_NEW_PROXY_URL')}${config('USER_ACCEPTANCE_TOU')}`, {
        withCredentials: 'include',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...args }),
      })
        .then((res) => {
          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('USER_ACCEPTANCE_TOU'),
              userInfo: args?.userInfo,
              method: 'POST',
              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,
              // result: hasReportCode ? 'success' : 'error',
            },
          });
          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('FEEDBACK_URL'),
            status: 0,
            message: 'Success',
            url: window.location.href,
            result: 'success',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
          return res.status;
        })
        .then((res) => {
          const statusJson = { status: res };
          if (res !== 200) {
            dispatch({
              type: `${ACTION_TYPE}_ERROR`,
              payload: statusJson,
            });
          } else {
            dispatch({
              type: `${ACTION_TYPE}_COMPLETED`,
              payload: statusJson,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('USER_ACCEPTANCE_TOU'),
              userInfo: args?.userInfo,
              method: 'POST',
              operationName: ACTION_TYPE,
            },
          });

          event('API_TRANSACTION_ERROR', {
            actionId: dtrumActionId,
            endpoint: config('USER_ACCEPTANCE_TOU'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
          });
        })
        .finally(() => {
          const outcome = status && status === 200 ? 'success' : 'error';

          if (transaction) {
            transaction.addLabels({
              result: outcome,
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('USER_ACCEPTANCE_TOU'),
              method: 'POST',
              code: status,
              message: statusText,
              ...getUserInfoDataForEAPM(args?.userInfo),
              operationName: ACTION_TYPE,
            });

            transaction.end({ outcome });
          }
        });
    };
  });

  return [result, action];
};
